// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".earned-coupon td[data-v-64e605a2]{padding:8px;line-height:20px;text-align:left;vertical-align:top;border-top:1px solid #ddd}", ""]);
// Exports
module.exports = exports;
